<div *appProjectRoleAccess="projectManagerConfig()" class="flex justify-end mb-3">
  <p-button
    icon="pi pi-ellipsis-v"
    class="p-button-text p-button-rounded p-button-plain"
    (onClick)="onDotMenuClick($event)"
    severity="secondary"
    [attr.data-testid]="testId()"
  ></p-button>
  <p-menu #dotMenu popup="true"></p-menu>
</div>
